import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      alignItems: "flex-start",
      height: "66px",
    },
    label: {
      display: "flex",
      flexDirection: "row",
      gap: "3px",
    },
    labelText: {
      color: "#6B6B6C",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "18px",
    },
    icon: {
      lineHeight: "7px",
    },
    datePicker: {
        height: "44px",
        borderRadius: "10px",
        backgroundColor: "white",
        "& fieldset": {
            borderColor: "#B9BEC7",
            borderRadius: "10px",
        },
    },
    textField: {
        placeholder: "hint",       
        variant: "outlined", 
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            height: "44px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#B9BEC7",
        },
    }
  })();
};
